import { render, staticRenderFns } from "./car-report.vue?vue&type=template&id=2196b4f9"
import script from "./car-report.vue?vue&type=script&lang=js"
export * from "./car-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports